import style from './TableSamples.module.css';

import { useEffect } from 'react';
import { useDrop } from 'react-dnd';
import { moveSample } from 'services/sample.services';
import classNames from 'classnames';
import { modalStore } from 'store/mobx/modal.store';
import useAlert from 'hooks/useAlert';
import { storageStore } from 'store/mobx/storage.store';
import { observer } from 'mobx-react-lite';

const EmptyItem = observer((props) => {
  const { packId, line, column, storageId, cell, mode } = props;
  const rules = mode.rules ?? {};
  const {
    setSelectedEmptyCellForCopy,
    deleteSelectedEmptyCellForCopy,
    selectedEmptyCellForCopy,
    selectedCell,
    editSelectedCell,
    refreshSamples,
  } = storageStore;

  const { showAlert } = useAlert();

  useEffect(() => {
    return () => {
      modalStore.closeModal('sampleType');
    };
  }, []);

  const [_, drop] = useDrop(
    () => ({
      accept: ['sample'],
      drop: async (item) => {
        if (item.packId === packId && line === item.line && column === item.column) return;
        let settings = {
          id: item.sampleId,
          volume: item.value,
          new_storage: storageId ?? 0,
          new_pack: packId,
          column: column,
          line: line,
        };
        let res = await moveSample(item.sampleId, settings);
        if (res.success) {
          await refreshSamples();
        } else {
          showAlert('Произошла ошибка при попытке переместить образец', 'error');
        }
      },
    }),
    [packId, line, column, storageId],
  );

  const checkCell = () => {
    if (storageId !== undefined)
      return selectedCell.find(
        (i) =>
          i.packId === packId &&
          i.column === cell.column &&
          i.line === cell.line &&
          i.storageId === storageId,
      );
    return selectedCell.find(
      (i) => i.packId === packId && i.column === cell.column && i.line === cell.line,
    );
  };

  const checkCellInCopyMode = () => {
    return selectedEmptyCellForCopy.some(
      (i) =>
        i.packId === packId && i.line === line && i.column === column && i.storageId === storageId,
    );
  };

  const addCellToCopyMode = () => {
    setSelectedEmptyCellForCopy({
      packId: packId,
      line: line,
      column: column,
      storageId: storageId,
    });
  };

  const deleteCellInCopyMode = () => {
    deleteSelectedEmptyCellForCopy({
      packId: packId,
      line: line,
      column: column,
      storageId: storageId,
    });
  };

  const handlerClickSell = async (e) => {
    if (e.ctrlKey) {
      if (!rules?.sample?.move) return;
      if (checkCellInCopyMode()) {
        deleteCellInCopyMode();
      } else {
        addCellToCopyMode();
      }
    } else {
      if (!rules?.sample?.upsert) return;

      modalStore.openModal('sampleType', { line, column, storageId, packId, mode }, true);
    }
  };

  return (
    <div className={style.table_item_block} ref={drop}>
      <div
        className={classNames(style.table_item, {
          [style.table_border_green]: checkCell() || checkCellInCopyMode(),
        })}
        style={{
          backgroundColor: checkCellInCopyMode() ? 'lightgray' : 'white',
          opacity: checkCellInCopyMode() ? 0.8 : 1,
        }}
        onClick={handlerClickSell}
      >
        {!checkCellInCopyMode() && rules?.sample?.upsert && (
          <div className={style.table_item_add_block}>
            <div className={style.table_item_add} />
          </div>
        )}
      </div>
      {!checkCellInCopyMode() && rules?.sample?.upsert && (
        <div
          className={classNames(style.table_item_delete, {
            [style.table_item_green]: checkCell(),
          })}
          onClick={() =>
            editSelectedCell({
              packId: packId,
              storageId: storageId,
              column: cell.column,
              line: cell.line,
            })
          }
        >
          <div className={style.table_item_select_svg} />
        </div>
      )}
    </div>
  );
});

export default EmptyItem;
